import type { HighlighterProfileExportResult } from './rtk/enhancers/export-by-identifier';
import { withHighlighterProfileExport } from './rtk/enhancers/export-by-identifier';
import * as recruiting from './rtk/enhancers/recruiting';
import { projectOrchestratorApi as _projectOrchestratorApi } from './rtk/rtk.generated';
import type * as ProjectOrchestratorApiTypes from './rtk/rtk.generated';

export type { ProjectOrchestratorApiTypes };
export type { HighlighterProfileExportResult };

export const projectOrchestratorApi = withHighlighterProfileExport(
  recruiting.enhance(_projectOrchestratorApi),
);

export type ProjectOrchestratorApi = typeof _projectOrchestratorApi;
